import { Outlet, Link, router, useParams, useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef, useMemo } from "react";
import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheck/page";
import { ApiAdmin, API, MAPS_API_KEY } from "../../Values";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
const mapContainerStyle = {
  width: "100%",
  height: "100%",
};

const center = {
  lat: 30.033, // الموقع الافتراضي
  lng: 31.233,
};
export default function AdressAdd(Search) {
  const [AdressLocation, setAdressLocation] = useState(center);
  const [AdressName, setAdressName] = useState("");
  const [AdressTitle, setAdressTitle] = useState("");

  const [isLoaded, setIsLoaded] = useState(false); // حالة تحميل الخريطة
  const [currentLocation, setCurrentLocation] = useState(null); // الموقع الحالي للمستخدم
  const [map, setMap] = useState(null);
  const searchInputRef = useRef();
  const autocompleteRef = useRef();
  const navigate = useNavigate();
  const libraries = useMemo(() => ["places", "geometry"], []);
  const [isLoading, setIsLoading] = useState(true);
  const [Inputs, setInputs] = useState([]);
  const [errors, Seterrors] = useState("");
  //---------ShowModal----------------------------
  const [ShowModal, SetShowModal] = useState(false);
  const handleCloseModal = () => SetShowModal(false);
  const handleShowModal = () => SetShowModal(true);
  //--------------------------------------
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const handleDubelClick = (e) => {
    const name = e.target.name;
    const value = "";
    setInputs((values) => ({ ...values, [name]: value }));
  };
  //---------CHECK LOGIN ------------------------------
  LoginCheck();
  var userinfo = [];
  var Username = "";
  var UserID = "";
  if (Cookies.get("userinfo")) {
    userinfo = JSON.parse(Cookies.get("userinfo"));
    Username = userinfo[0].Name;
    UserID = userinfo[0].ID;
  }

  const [MAPS_API_KEY_, SET_MAPS_API_KEY] = useState(MAPS_API_KEY);
  useEffect(() => {
    GetApiKey();
  }, []);
  async function GetApiKey() {
    try {
      const type = "Google Maps";
      const post = {
        type: type,
        Action: "GetApiType",
      };
      const response = await fetch(ApiAdmin + "/Api_Setting.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      console.log("============  get api ===============");
      // console.log(data[0].token);
      SET_MAPS_API_KEY(data[0].token);
    } catch (error) {
      return error;
    }
  }
  //--------------------------------------

  useEffect(() => {
    GetMyLocation();
  }, []);

  function GetMyLocation() {
    const savedCurentLocation = JSON.parse(
      localStorage.getItem("CurentLocation")
    );
    if (savedCurentLocation) {
      // setAdressLocation(savedCurentLocation.location);
      // setAdressName(savedCurentLocation.name);
      getPlaceName(savedCurentLocation.location.lat, savedCurentLocation.location.lng);
      setIsLoading(false);

    }
    console.log("CurentLocation");
    console.log(savedCurentLocation);
  }



  useEffect(() => {
    if (window.google && window.google.maps) {
      const input = searchInputRef.current;
      const autocomplete = new window.google.maps.places.Autocomplete(input);
      autocompleteRef.current = autocomplete;
      // عند تحديد مكان من الـ  Autocomplete
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place.geometry) {
          const location = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };
          setAdressLocation(location);
          getPlaceName(location.lat, location.lng);
          console.log(location);
          // تحريك الخريطة إلى الموقع المحدد
          if (map) {
            map.panTo(location); // تحريك الخريطة إلى المكان المحدد
            map.setZoom(14); // تحديد مستوى التكبير عند النقطة
          }
        }
      });
    }
  }, [map]);

  const handleMapClick = async (event) => {
    const latLng = event.latLng;
    const location = {
      lat: latLng.lat(),
      lng: latLng.lng(),
    };
    setAdressLocation(location);
    getPlaceName(location.lat, location.lng);
    if (map) {
      map.panTo(location); // تحريك الخريطة إلى المكان المحدد
      map.setZoom(14); // تحديد مستوى التكبير عند النقطة
    }
  };


  const getPlaceName = async (latitude, longitude) => {
    try {
      const location = {
        lat: latitude,
        lng: longitude,
      };
      const response = await axios.get(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json&accept-language=ar`);
      setAdressLocation(location);
      setAdressName(response.data.display_name);
      setIsLoading(false);
      console.log(location);
      console.log(response.data.display_name);
    } catch (error) {
      console.error('خطأ في جلب اسم الموقع:', error);
    }
  };

  const getPlaceName0 = (lat, lng) => {
    const location = {
      lat: lat,
      lng: lng,
    };
    const geocoder = new window.google.maps.Geocoder();
    const latLng = new window.google.maps.LatLng(lat, lng);
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results[0]) {
        setAdressName(results[0].formatted_address);
        // setDeliveryLocation(location);
        // localStorage.setItem(
        //   "deliveryLocation",
        //   JSON.stringify({ location, name: results[0].formatted_address })
        // );
      }
    });
  };

  //----------------------------------------
  const convertArabicNumbersToEnglish = (input) => {
    if (!input) return "";

    // استبدال الأرقام
    const arabicToEnglishMap = {
      "٠": "0",
      "١": "1",
      "٢": "2",
      "٣": "3",
      "٤": "4",
      "٥": "5",
      "٦": "6",
      "٧": "7",
      "٨": "8",
      "٩": "9",
    };

    // تحويل الأرقام والفواصل
    return input
      .replace(/[٠-٩]/g, (digit) => arabicToEnglishMap[digit]) // استبدال الأرقام
      .replace(/،/g, ","); // استبدال الفاصلة
  };

  // تحميل الخريطة وتغيير حالة isLoaded عند الانتهاء
  const handleLoad = () => {
    setIsLoaded(true); // الخريطة أصبحت جاهزة
  };

  const SaveLocation = async () => {
    var AdressTitle = Inputs.AdressTitle;
    if (AdressTitle == null) {
      AdressTitle = "";
    }
    if (AdressLocation) {
      if (window.confirm("هل تريد اضافة عنوان جديد")) {
        try {
          const post = {
            Name: Username,
            ID: UserID,
            Action: "AddAdress",
            AdressName: AdressName,
            AdressLat: AdressLocation.lat,
            AdressLng: AdressLocation.lng,
            AdressTitle: AdressTitle
          };
          const response = await fetch(API.CustomerAccount, {
            method: "POST",
            body: JSON.stringify(post),
          });
          const data = await response.json();
          if (data.errors != "") {
            Seterrors(data.errors);
            handleShowModal();
          }
          if (data.msg != "") {
            Seterrors(data.msg);
            handleShowModal();
          }
        } catch (error) {
          return error;
        }
      }
    } else {
      alert("يرجى تحديد العنوان المراد حفظه أولاً.");
    }
  };

  //-----------------------------------------
  const params = useParams();
  const imgstyle = {
    height: "100%",
  };

  return (
    <>
      <div
        className="p-1 row  text-center m-auto bg-white"
        style={{ maxWidth: "500px" }}
      >
        <div className="col-12 py-2 text-center bg-light mb-1">
          <span className="fs-6 fw-bold"> اضافة عنوان   </span>
          <Link to="../Customer/AdressSaved" className="float-start">
            <i className="fa-solid fa-xmark  fs-4 "></i>
          </Link>
        </div>
        <div className="col-12 p-1">
          <input
            type="text"
            id="pickup-search"
            placeholder="ابحث فى الخريطة"
            ref={searchInputRef}
            style={{ width: "100%", padding: "10px" }}
            className="searchText"
          />
        </div>
        <div className="col-12 div-mapTo0 bg-light0 mb-2 text-end p-0 m-0" style={{ height: "45vh" }}>

          <LoadScript
            googleMapsApiKey={MAPS_API_KEY_}
            libraries={libraries}
            onLoad={handleLoad} // تعيين isLoaded على true بعد تحميل المكتبة
          >
            {isLoaded ? (
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={AdressLocation}
                zoom={14}
                onClick={handleMapClick} // عند النقر على الخريطة
                onLoad={(mapInstance) => setMap(mapInstance)} // عندما يتم تحميل الخريطة
              >
                {AdressLocation && (
                  <Marker position={AdressLocation} label="العنوان" />
                )}

              </GoogleMap>
            ) : (
              <div>الخريطة في مرحلة التحميل... يرجى الانتظار</div> // عرض رسالة مخصصة عند تحميل الخريطة
            )}
          </LoadScript>
        </div>
        <div className="col-12 px-2 bg-greenLight text-end p-3" style={{ borderRadius: "10px" }}>
          <i className="fa-solid fa-location-dot text-green  mx-2"></i>
          <span>{AdressName || "لم يتم تحديد عنوان"}</span>
          {/* <br />
          <span>{distance}</span> */}
        </div>
        <div className="col-12 my-4 p-1 text-end">
          <h6>تفاصيل اضافية</h6>
          <input
            type="text"
            name="AdressTitle"
            value={Inputs.AdressTitle}
            onChange={handleChange}
            onClick={handleDubelClick}
            className="form-control"
            placeholder="رقم المنزل / العمارة / الشقة (اختيارى)"
          />
          {/* <button
            className="btn btn-green w-100 fw-bold p-2 mt-3"
            onClick={() => SaveLocation()}
          >
            {" موقع تسليم الشحنة"}
          </button> */}
        </div>
      </div>
      <div className="row buttom-div p-1 bg-white">
        <div className="col-12 text-center pt-2 mb-2">
          <button
            className="btn btn-green w-75 p-2 fw-bold radius"
            style={{ borderRadius: "50px" }}
            onClick={() => SaveLocation()}
          >
            {" حفظ العنوان"}
          </button>
        </div>
      </div>
      <MSG />
    </>
  );

  function MSG() {
    return (
      <>
        <Modal show={ShowModal} onHide={handleCloseModal}>
          <Modal.Body>
            <div className="row">
              <div className="col-12 text-center">
                <h4 className="text-start p-0 m-0">خطا </h4>
                <hr />
                <h5 className=" text-center ">{errors}</h5>
                <button
                  onClick={() => handleCloseModal()}
                  className="btn btn-danger w-50 m-3"
                >
                  OK
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
